import React from 'react'

import { connect } from 'react-redux'

import StyleSheetEditor from './stylesheet-editor'
import AssetEditor from './asset-editor'
import AssetUploader from './asset-uploader'
import BrandsSelector from './brands-selector'
import CategoryFeatureDisplay from './category-feature-display'

import {
    setActiveCategoryFeature,
    updateCategoryFeature,
    setName
} from '../actions'

import {
    Row,
    Col,
    Input,
    Card,
    Button,
    message
} from 'antd'

class CategoryFeature extends React.Component {
    render(){

        const { 
            name
        } = this.props.activeCategoryFeature

        return (
            <div style={{
                padding: 24
            }}>
                <Card 
                title ={<Row 
                    justify="space-between"
                    align="middle"
                    type="flex">
                        <Col>
                            <Input
                                onChange={this.handleNameChange}
                                value={name}
                            />
                        </Col>
                        <Col>
                            <Button
                            type="primary"
                            onClick={this.handleSave}>
                                Save
                            </Button>
                        </Col>
                    </Row>}
                >
                    <Row 
                    gutter={24}
                    type="flex">
                        <Col span={12}>
                            <Row>
                                <AssetUploader/>
                            </Row>
                            <Row>
                                <Row>
                                    <BrandsSelector/>
                                </Row>
                                <Row>
                                    <AssetEditor/>
                                </Row>
                            </Row>
                            <Row>
                                <StyleSheetEditor/>
                            </Row>
                        </Col>
                        <Col span={12}>
                            <CategoryFeatureDisplay/>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
    
    componentDidMount(){
        this.props.setActiveCategoryFeature(this.props.categoryFeatureId)
    }

    handleSave = () => {
        this.props.updateCategoryFeature(this.props.activeCategoryFeature)
    }

    handleNameChange = (e) => {
        this.props.setName(e.target.value)
    }

}
export default connect(
    state => ({
        activeCategoryFeature: state.categoryFeatures.activeCategoryFeature,
        loading: state.categoryFeatures.loading
    }),
    dispatchEvent => ({
        setActiveCategoryFeature: (categoryFeatureId) => dispatchEvent(setActiveCategoryFeature(categoryFeatureId)),
        updateCategoryFeature: (categoryFeature) => dispatchEvent( updateCategoryFeature( categoryFeature )).then( res => {
            if( res.value.status == 200 ){
                return message.success("Save success!")
            }

            return message.error("Failed to save")

        }),
        setName: (name) => dispatchEvent( setName( name ))
    })
)(CategoryFeature)


// WEBPACK FOOTER //
// ./src/components/category-feature/editor/index.js